import { QueryClientProvider as BaseQueryClientProvider } from '@tanstack/react-query';
import { PropsWithChildren } from 'react';
import { queryClient } from './query-client';

export function QueryClientProvider({ children }: PropsWithChildren) {
    return <BaseQueryClientProvider client={queryClient}>{children}</BaseQueryClientProvider>;
}
